// extracted by mini-css-extract-plugin
export default {"loading":"Loading_loading__HTZsm","fixed":"Loading_fixed__8MhG5","lds-ripple":"Loading_lds-ripple__G8VbP","hide":"Loading_hide__8wfKC"};